<div class="flex relative overflow-hidden min-h-screen flex-col justify-center py-12 lg:px-8 bg-gray-50">
    <app-background></app-background> <!-- CIRCULOS DEL FONDO DE LA PAGINA-->
    <div class="max-w-[540px] mt-10 sm:mx-auto sm:w-full">
        <div class="bg-white opacity-99 px-6 py-12 rounded-lg sm:px-12">
            <div class="sm:mx-auto sm:w-full sm:max-w-md">
                <img class="mx-auto h-10 md:h-12 lg:h-15 xl:h-18 w-auto" src="../../assets/img/LogoHos.svg"
                    alt="Cognitive">
            </div>
            <div class="space-y-6">
                <div>
                    <label for="usuario" class="block text-sm/6 font-medium text-gray-900">Usuario</label>
                    <div class="mt-2">
                        <input id="usuario" class="input-login" type="text" id="usuario" placeholder="Ingresar usuario"
                            required>
                    </div>
                </div>

                <div>
                    <label for="password" class="block text-sm/6 font-medium text-gray-900">Contraseña</label>
                    <div class="mt-2 relative">
                        <input id="password" type="{{ showPassword() ? 'text' : 'password' }}" required
                            class="input-login" placeholder="Ingresar contraseña" />
                        <button type="button" class="absolute right-3 top-2 text-gray-400 hover:text-gray-600"
                            (click)="togglePasswordVisibility()">
                            @if (!showPassword()) {
                            <i class="material-symbols-outlined mr-1 align-text-bottom">visibility</i>
                            } @else {
                            <i class="material-symbols-outlined mr-1 align-text-bottom">visibility_off</i>
                            }
                        </button>
                    </div>
                </div>

                <div class="flex items-center justify-between">
                    <div class="text-sm/6">
                        <a href="#" class="font-semibold text-gray-900 hover:text-pink-500">¿Olvidaste tu
                            contraseña?</a>
                    </div>
                </div>

                <div>
                    <button class="button-submit">Ingresar</button>
                </div>
            </div>

            <div>
                <div class="relative mt-10">
                    <div class="absolute inset-0 flex" aria-hidden="true">
                        <div class="w-full border-t-2 border-gray-200"></div>
                    </div>
                    <div class="relative flex justify-center text-sm/6 font-medium">
                        <a routerLink="/register" class="font-semibold text-gray-900 hover:text-pink-500 mt-1">Crear
                            Cuenta</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>